// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3hMHR","select":"Header_select__1K6N5","clinic":"Header_clinic__2Vukv"};